import React, { useMemo } from "react";
import LGModalCrud from "../LGCrud/LGModalCrud";
import PoItemForm from "./PoItemForm";
import { formatCurrency, formatPercentage } from "../../services/valueFormatters";
import { deletePOItem, getPOItemList } from "../../api/purchaseOrders";
import { mapItemToRow, toNumber } from "./poItemHelpers";

const PODetailMaterialModalCrud = ({
  purchaseOrderId,
  companyId,
  isImport = false,
  expenseAccounts = [],
  units = [],
  onItemsChanged,
}) => {
  const formProps = useMemo(
    () => ({
      purchaseOrderId,
      companyId,
      isImport,
      expenseAccounts,
      units,
      onItemsChanged,
    }),
    [purchaseOrderId, companyId, isImport, expenseAccounts, units, onItemsChanged],
  );

  const columns = useMemo(
    () => [
      {
        field: "expenseAccount",
        headerName: "Actividad",
        flex: 1,
        valueGetter: (_, row) => row.expenseAccount?.name || "",
      },
      {
        field: "quantity",
        headerName: "Cantidad",
        type: "number",
        flex: 0.8,
      },
      {
        field: "unit",
        headerName: "Unidad",
        flex: 0.8,
        valueGetter: (_, row) => row.unit?.code || "",
      },
      {
        field: "concept",
        headerName: "Concepto",
        flex: 1.5,
      },
      {
        field: "product",
        headerName: "Producto",
        flex: 0.9,
        valueGetter: (_, row) => row.product?.code || "",
      },
      {
        field: "price",
        headerName: "Precio unitario",
        type: "number",
        flex: 1,
      },
      {
        field: "workOrderId",
        headerName: "Orden de trabajo",
        flex: 1,
      },
      {
        field: "discountPercentage",
        headerName: "Descuento (%)",
        flex: 1,
        valueFormatter: (value) => formatPercentage(toNumber(value)),
      },
      {
        field: "subtotal",
        headerName: "Subtotal",
        flex: 1,
        valueFormatter: (value) => formatCurrency(toNumber(value)),
      },
      {
        field: "taxRate",
        headerName: "Tasa IVA",
        flex: 0.8,
        valueFormatter: (value) => `${toNumber(value)}%`,
      },
    ],
    [],
  );

  const crudProps = useMemo(
    () => ({
      actions: ["create", "update", "delete"],
      serverDrivenPagination: false,
      data: { purchaseOrderId },
      fetchFunction: async () => {
        const response = await getPOItemList({ purchaseOrderId });
        return {
          data: (response.data || []).map((item, index) =>
            mapItemToRow(item, index, isImport),
          ),
        };
      },
      deleteFunction: async (id) => {
        await deletePOItem(id);
        onItemsChanged?.();
      },
      columns,
      addModalData: {
        header: "Nuevo Concepto",
        body: <PoItemForm {...formProps} />,
      },
      editModalData: {
        header: "Editar Concepto",
        body: <PoItemForm {...formProps} />,
      },
      search: false,
      dataGridProps: {
        getRowHeight: () => "auto",
        sx: {
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },
        },
      },
    }),
    [columns, formProps, purchaseOrderId, isImport, onItemsChanged],
  );

  return <LGModalCrud props={crudProps} />;
};

export default PODetailMaterialModalCrud;
